import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentLimitExceeded = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.isLimitExceeded,
)
